module.exports = __webpack_public_path__ + "media/assets/images/rain-375bb89d27ae26e834109fce8944c866.png";